import React from 'react';
import styled from 'styled-components';
import { StaticQuery, graphql } from 'gatsby';
import GatsbyImage from 'gatsby-image';
import { Title } from './HomePage/HomepageSectionOne';

const PartnersSection = styled.div`
  display: grid;
  justify-items: center;
  width: 100%;
  background-color: #323f6d;
  grid-template-columns: repeat(12, 1fr);
`;

const PartnersSideBackground = styled.div`
  background-color: #26315c;
  width: 100%;
  height: calc(100%);
  clip-path: polygon(3.5rem 0, 100% 0, 100% 100%, 0% 100%);
`;

const PartnersSide = styled.div`
  grid-column: span 3;
  display: grid;
  position: relative;
  width: 100%;

  @media (max-width: 768px) {
    display: none;
  }
`;

const PartnerTitle = styled(Title)`
  color: white;
`;

const PartnersBanner = styled.div`
  display: none;
  @media (max-width: 768px) {
    background-color: #26315c;
    display: grid;
    width: 100%;
    grid-column: span 12;
    height: 100px;
    justify-items: center;
    align-items: center;
  }
`;

const PartnersSideContainer = styled(Title)`
  color: #ffffff;
  position: absolute;
  top: 2rem;
  margin-left: 5rem;
  margin-top: 0rem;

  font-size: 28px;
  @media (max-width: 1024px) {
    font-size: 24px;
  }
  @media (max-width: 520px) {
    font-size: 28px;
  }
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  letter-spacing: normal;

  @media (max-width: 520px) {
    display: none;
  }
`;

const PartnersGrid = styled.div`
  display: grid;
  grid-column: span 9;
  padding-left: 25%;
  grid-template-columns: ${(props: { count: number }) =>
    `repeat(${props.count}, 1fr)`};
  grid-gap: 80px;
  /* grid-gap: 3rem; */
  margin-top: 1rem;
  margin-bottom: 1rem;
  @media (max-width: 1100px) {
    grid-gap: 50px;
  }
  @media (max-width: 900px) {
    grid-gap: 40px;
  }
  @media (max-width: 768px) {
    grid-gap: 70px;
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 520px) {
    grid-gap: 20px;
    grid-column: span 12;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1.5rem;
    padding-left: 0%;
    margin-bottom: 1rem;
    margin-top: 1rem;
  }
`;

const PartnersItem = styled(GatsbyImage)`
  min-width: 130px;
  height: 62px;
  max-width: 100%;
  align-self: center;
  opacity: 0.9;
  transition: opacity 0.2s ease-in-out;
  &:hover {
    opacity: 1;
  }
  @media (max-width: 1100px) {
    width: 100px;
  }
  @media (max-width: 768px) {
    width: 10rem;
  }
  @media (max-width: 520px) {
    width: 30vw;
    height: 50px;
  }
  img {
    object-fit: contain !important;
  }
`;

const PartnersItemAmp = styled.img`
  min-width: 130px;
  height: auto;
  max-width: 100%;
  align-self: center;
  opacity: 0.9;
  transition: opacity 0.2s ease-in-out;
  &:hover {
    opacity: 1;
  }
  @media (max-width: 1100px) {
    width: 100px;
  }
  @media (max-width: 768px) {
    width: 10rem;
  }
  @media (max-width: 520px) {
    width: 30vw;
    height: auto;
  }
  img {
    object-fit: contain !important;
  }
`;

export default class PartnersHomepage extends React.Component<any, any> {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            lenovo: file(
              relativePath: { eq: "v2/png/careers/partners/Lenovo.png" }
            ) {
              childImageSharp {
                fluid(quality: 95) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                  srcWebp
                  srcSetWebp
                }
              }
            }

            zebra: file(
              relativePath: { eq: "v2/png/careers/partners/zebra.png" }
            ) {
              childImageSharp {
                fluid(quality: 95) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                  srcWebp
                  srcSetWebp
                }
              }
            }

            android: file(
              relativePath: { eq: "v2/png/careers/partners/android.png" }
            ) {
              childImageSharp {
                fluid(quality: 95) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                  srcWebp
                  srcSetWebp
                }
              }
            }

            google: file(
              relativePath: { eq: "v2/png/careers/partners/google.png" }
            ) {
              childImageSharp {
                fluid(quality: 95) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                  srcWebp
                  srcSetWebp
                }
              }
            }

            innocom: file(
              relativePath: { eq: "v2/png/careers/partners/innocom.png" }
            ) {
              childImageSharp {
                fluid(quality: 95) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                  srcWebp
                  srcSetWebp
                }
              }
            }

            mediateknew: file(
              relativePath: { eq: "v2/png/careers/partners/mtklogo.png" }
            ) {
              childImageSharp {
                fluid(quality: 95) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                  srcWebp
                  srcSetWebp
                }
              }
            }

            mediatek: file(
              relativePath: { eq: "v2/png/careers/partners/Mediatek.png" }
            ) {
              childImageSharp {
                fluid(quality: 95) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                  srcWebp
                  srcSetWebp
                }
              }
            }
          }
        `}
        render={(data: any) => (
          <PartnersSection>
            <PartnersBanner>
              <PartnerTitle>{this.props.title ?? 'Our Partners'}</PartnerTitle>
            </PartnersBanner>
            <PartnersGrid count={this.props.companies.length}>
              {this.props.companies.map((item: any) => {
                return this.props.isAmp ? (
                  <PartnersItemAmp
                    key={item}
                    src={data[`${item}`].childImageSharp.fluid?.src}
                  />
                ) : (
                  <PartnersItem
                    key={item}
                    loading="lazy"
                    fluid={data[`${item}`].childImageSharp.fluid}
                    alt={item}
                  />
                );
              })}
            </PartnersGrid>
            <PartnersSide>
              <PartnersSideBackground />
              <PartnersSideContainer>
                {this.props.title ?? 'Our Partners'}
              </PartnersSideContainer>
            </PartnersSide>
          </PartnersSection>
        )}
      />
    );
  }
}
